const CopyIconSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M13.7812 16.3125H7.21875C5.586 16.3125 4.6875 15.414 4.6875 13.7812V7.21875C4.6875 5.586 5.586 4.6875 7.21875 4.6875H13.7812C15.414 4.6875 16.3125 5.586 16.3125 7.21875V13.7812C16.3125 15.414 15.414 16.3125 13.7812 16.3125ZM7.21875 5.8125C6.21975 5.8125 5.8125 6.21975 5.8125 7.21875V13.7812C5.8125 14.7802 6.21975 15.1875 7.21875 15.1875H13.7812C14.7802 15.1875 15.1875 14.7802 15.1875 13.7812V7.21875C15.1875 6.21975 14.7802 5.8125 13.7812 5.8125H7.21875ZM2.8125 11.25V4.21875C2.8125 3.21975 3.21975 2.8125 4.21875 2.8125H11.25C11.5605 2.8125 11.8125 2.5605 11.8125 2.25C11.8125 1.9395 11.5605 1.6875 11.25 1.6875H4.21875C2.586 1.6875 1.6875 2.586 1.6875 4.21875V11.25C1.6875 11.5605 1.9395 11.8125 2.25 11.8125C2.5605 11.8125 2.8125 11.5605 2.8125 11.25Z'
        fill='#25314C'
      />
    </svg>
  );
};

export default CopyIconSVG;
